import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../../Component/Layouts/App/Candidates/StudentApp/Icon';
import { useWeb } from '../../../../Component/Layouts/Web/Student/WebContext';
import { WEB_BASE } from '../../../../Component/Layouts/Web/Student/WebLayout';
import { profileStats, skills } from '../../../../Component/Layouts/App/Candidates/StudentApp/studentData';

const Profile = () => {
  const navigate = useNavigate();
  const { xp, toggleTheme, showToast } = useWeb();

  return (
    <>
      <div className="web-h">
        <div className="web-row">
          <span className="web-av" style={{ width: 72, height: 72, fontSize: 22 }}>AS</span>
          <div>
            <h1>Aditi Sharma</h1>
            <p>Level 7 · {xp.toLocaleString()} XP</p>
          </div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button type="button" className="web-icon" aria-label="Theme" onClick={toggleTheme}><Icon name="zap" /></button>
          <button type="button" className="web-btn" onClick={() => showToast('Edit profile')}>Edit profile</button>
        </div>
      </div>
      <div className="web-card web-stats" style={{ marginBottom: 16 }}>
        {profileStats.map((stat) => (
          <div key={stat.label}>
            <Icon name={stat.icon} />
            <b>{stat.value}</b>
            <span>{stat.label}</span>
          </div>
        ))}
      </div>
      <div className="web-grid two">
        <div className="web-card">
          <b>Skills</b>
          <div>
            {skills.map((skill) => <span className="web-tag" key={skill}>{skill}</span>)}
          </div>
          <button type="button" className="web-btn soft" style={{ marginTop: 14 }} onClick={() => showToast('Add a skill')}>+ Add skill</button>
        </div>
        <div className="web-card">
          <b>About me</b>
          <p className="web-mut">
            Passionate learner, creative thinker and team player. Excited about building a positive impact through technology and community.
          </p>
          <div className="web-grid two" style={{ marginTop: 12 }}>
            <button type="button" className="web-shot" onClick={() => navigate(`${WEB_BASE}/achievement`)}><Icon name="trophy" /></button>
            <button type="button" className="web-shot alt" onClick={() => navigate(`${WEB_BASE}/achievements`)}><Icon name="file" /></button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Profile;
